exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.worldpay3ds[data-v-5be3ba28] {\n}\n\n", ""]);

// exports
